module.exports = __webpack_public_path__ + "files/226b442f295659e07f2a07f4d8518f79.png";